import React from "react";
import "../assets/styles/components/Loader.scss";
import load from "../assets/static/images/portal.gif";

const Loader = () => (
  <div className="loader">
    <img className="loader-img" src={load} alt="Load" />
    <span className="loader-text"> Loading...</span>
  </div>
);

export default Loader;
